import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DiscountsRoutingModule } from './discounts-routing.module'
import { DiscountsSharedModule } from './discounts-shared.module'
import { DiscountsComponent } from './discounts/discounts.component'

const components = [
  //
  DiscountsComponent,
]

@NgModule({
  declarations: [...components],
  imports: [CommonModule, DiscountsRoutingModule, DiscountsSharedModule],
})
export class DiscountsModule {}
